var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCatalog = function SvgCatalog(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.405 6v9.452h4.258c.636 0 1.163.087 1.58.283.153.065.307.152.439.24V6.893c-.198-.305-.417-.523-.725-.675C10.628 6.065 10.19 6 9.663 6zm4.258 10.105H5.075a.32.32 0 0 1-.329-.326V7.394H4v9.473h5.026c1.141 0 1.734.153 2.239 1.133h1.47c.505-.98 1.12-1.133 2.239-1.133H20V7.394h-.746v8.385a.32.32 0 0 1-.33.326h-4.587c-.921 0-1.624.13-2.04.959-.11.26-.484.26-.593-.022-.373-.784-1.164-.937-2.041-.937m2.677-9.212v9.082c.527-.414 1.23-.523 1.997-.523h4.258V6h-4.258c-.526 0-.965.065-1.294.218a1.6 1.6 0 0 0-.703.675",
    clipRule: "evenodd"
  })));
};
export { SvgCatalog as ReactComponent };
export default __webpack_public_path__ + "static/media/catalog.398b889bc8a6336a087216f98c7c7f77.svg";